import moment from 'moment-timezone'
import 'moment/locale/pt-br'
moment.locale('pt-br')
export default moment
